import React, { useState, useEffect } from 'react'
import { Box, Textarea, Flex, Group, Button, Select } from '@mantine/core'
import { getDetailTemplateBroadcastOrder, sendBroadcastMessageOrder } from '../../../../../services/orders'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import LoadingData from '../../../../ui/LoadingData'

const FormBroadcastWhatsapp = ({ idOrder, onCloseModal }) => {
  const [loadingDetail, setLoadingDetail] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null)
  const [contactList, setContactList] = useState([])
  const [contentMessage, setContentMessage] = useState('')

  const handleSendMessage = async () => {
    setLoadingForm(true)
    const isGroupContact = contactList.find((val) => val.value === selectedContact).is_group || false
    const payload = {
      phone: selectedContact,
      is_group: isGroupContact,
      content: contentMessage
    }
    try {
      const response = await sendBroadcastMessageOrder(payload)
      if (response.success) {
        notificationSuccess('Send Broadcast Message Successfully', 'You have successfully sent a broadcast message')
        onCloseModal()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Send Broadcast Message Failed', `${errorMessage ? errorMessage : 'Please contact administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetTemplateBroadcast = async (orderId) => {
    setLoadingDetail(true)
    try {
      const response = await getDetailTemplateBroadcastOrder(orderId)
      if (response.success) {
        const { contact, content } = response
        const remapDataContact = contact.map((val) => {
          return {
            value: val.phone,
            label: `${val.name} - ${val.phone}`,
            is_group: val.is_group
          }
        })
        setContactList(remapDataContact)
        setSelectedContact(remapDataContact[0].value)
        setContentMessage(content)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingDetail(false)
    }
  }

  useEffect(() => {
    if (idOrder) {
      handleGetTemplateBroadcast(idOrder)
    }
  }, [idOrder])

  const mappingFormBroadcast = () => {
    return (
      <Box>
        <Box mb='md'>
          <Select
            name='selectedContact'
            value={selectedContact}
            label='Select Recipient'
            data={contactList}
            onChange={(val) => setSelectedContact(val)}
            size='xs'
            allowDeselect={false}
          />
        </Box>
        <Box mb='md'>
          <Textarea
            name='contentMessage'
            label="Message"
            description='Please edit this message as needed. Message are editable.'
            value={contentMessage}
            onChange={(val) => setContentMessage(val.target.value)}
            size='xs'
            autosize
            minRows={14}
            maxRows={14}
          />
        </Box>
        <Box mb='xl'>
          <Button size='xs' loading={loadingForm} variant="filled" disabled={selectedContact === null} onClick={() => handleSendMessage()}>Send Message</Button>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {loadingDetail ? <LoadingData /> : mappingFormBroadcast()}
    </Box>
  )
}

export default FormBroadcastWhatsapp